window.addEventListener('DOMContentLoaded', (event) => {
  if (!(window.location.href.indexOf("fr/team/payroll-automation?utm_source=facebook&utm_medium=cpc&utm_campaign=prospecting_payfit&utm_content=payfit") > -1)) { return; }

  $("#section-0 h1").text('Automatisez le paiement de vos salaires avec Payfit');

  $("#section-0 .subtitle").html("<p><strong>Simple, sécurisé, rapide&nbsp;</strong><br>Payez vos salariés en quelques secondes grâce à l'intégration Payfit x Qonto et concentrez-vous sur l'essentiel !</p>")

  var section3 = $("#section-3").clone();

  $("#section-3").remove();
  $('#section-0').after(section3);
  var lazyLoadInstance = new LazyLoad({
    elements_selector: "img.lazy",
    cancel_on_exit: false
  });
});
